import React from 'react';
import { ATMField, ATMForm, ATMGrid, ATMInput } from 'shared-it-appmod-ui';
import Lang from '../../../../libraries/language';
import { PilotFormSchema } from '../../../../models/pilot.model';

type IProp = {
  formRef: React.RefObject<HTMLFormElement>;
  defaultValues?: any;
  handleSubmit: (data) => void;
  handleEnable: (value) => void;
};

const PilotsForm: React.FC<IProp> = ({
  formRef,
  defaultValues = {},
  handleSubmit,
  handleEnable,
}) => {
  return (
    <div className="form-container">
      <ATMForm
        ref={formRef}
        onSubmit={handleSubmit}
        mode="onChange"
        defaultValues={defaultValues}
        validationSchema={PilotFormSchema}
      >
        {({ control, errors, formState }) => {
          handleEnable(formState.isDirty);

          return (
            <ATMGrid>
              <ATMGrid.Row columns="2">
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_PILOT_NAME}
                    name="name"
                    control={control}
                    as={ATMInput}
                    placeholder={Lang.LBL_ENTER}
                    required
                    error={errors.name}
                  />
                </ATMGrid.Column>
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_PILOT_PHONE}
                    name="phone"
                    control={control}
                    as={ATMInput}
                    placeholder={Lang.LBL_ENTER}
                    onChange={([_, { value }]) => value}
                    error={errors.phone}
                    isPhone
                  />
                  <ATMField
                    as={ATMInput}
                    type="hidden"
                    name="pilotId"
                    control={control}
                    error={errors.pilotId}
                  />
                </ATMGrid.Column>
              </ATMGrid.Row>
            </ATMGrid>
          );
        }}
      </ATMForm>
    </div>
  );
};

export default PilotsForm;
